'use client';

import type { FC, PropsWithChildren, ReactNode } from 'react';
import { Fragment } from 'react';
import { Typography } from '../Typography';
import styles from './TableList.module.css';

export interface TableListProps {
  header?: ReactNode;
  items: ReactNode[];
}

export const TableList: FC<PropsWithChildren<TableListProps>> = (props) => {
  const { header, items } = props;
  return (
    <div className={styles.root}>
      {header && (
        <>
          <div className={styles.row} data-header={true}>
            <Typography.Caption textAlign="center">{header}</Typography.Caption>
          </div>

          {items.length !== 0 && <div className={styles.rowDivider} />}
        </>
      )}

      {items.map((item, index) => (
        <Fragment key={index}>
          <div className={styles.row}>
            <Typography.Caption textAlign="center">{item}</Typography.Caption>
          </div>

          {items.length - 1 !== index && <div className={styles.rowDivider} />}
        </Fragment>
      ))}
    </div>
  );
};
